import * as React from 'react';
import { ICardBoardNameProps } from './types';
import { CLASS_CARD_DETAILS } from '../../../constants';
import './_CardBoardName.scss';
import { Button, Icon } from 'kui';
import * as _ from 'underscore';
import { CARD_BOARD_NAME_ANIMATION_TIMING, IS_SHOWED_CARD_BOARD_NAME_ANIMATION_SESSIONSTORAGE } from './constants';
import { AsidePanelContext } from '../../../../asidePanel/components/AsidePanel/constants';

export function CardBoardName({
    boardName,
    isShow,
    isShowAnimation,
    onClick
}: ICardBoardNameProps) {
    const { cardId } = React.useContext(AsidePanelContext);

    const className = CLASS_CARD_DETAILS + '-board-name';

    const onClickLinkHandler = (event: React.MouseEvent) => {
        event.preventDefault();
        onClick();
    };

    React.useEffect(() => {
        if (!isShow || !isShowAnimation) return;
        setTimeout(() => {
            const data = sessionStorage.getItem(IS_SHOWED_CARD_BOARD_NAME_ANIMATION_SESSIONSTORAGE);
            const newData = data ? JSON.parse(data) : {};
            sessionStorage.setItem(IS_SHOWED_CARD_BOARD_NAME_ANIMATION_SESSIONSTORAGE, JSON.stringify({
                ...newData,
                [cardId]: true,
            }));
        }, CARD_BOARD_NAME_ANIMATION_TIMING);
    }, [isShowAnimation]);

    if (!isShow) return null;

    return (
        <div className={`${className} ${isShowAnimation ? className + '--blink' : ''}`}>
            <Button
                className={className + '__button'}
                variant={'icon-text'}
                text={boardName}
                onClick={onClickLinkHandler}
            >
                <Icon xlink={'board'} size={16} />
            </Button>
        </div>
    );
};
